import map from 'lodash/map';
import { TYPE, TABLE } from '@/constants';

import RectangularTable from './rectangularTable';
import RoundedTable from './roundedTable';
import { TableSeat } from './tableSeat';

const mappings = {
  [TYPE.TABLE_RECTANGULAR]: RectangularTable,
  [TYPE.TABLE_ROUNDED]: RoundedTable,
};

export default class TableHelper {
  static fromJSON(params) {
    const { subtype } = params;
    return mappings[subtype].fromJSON(params);
  }

  static addTable(type, position, params) {
    const seatsCount = type === TYPE.TABLE_RECTANGULAR ? TABLE.RECTANGULAR.SEATSCOUNT : TABLE.ROUNDED.SEATSCOUNT;
    const seats = map(new Array(seatsCount), (val, orderid) => TableSeat.create({ attributes: { orderid } }));
    const tableParams = Object.assign({}, params, { seats, attributes: { position } });
    const table = mappings[type].create(tableParams);
    return table;
  }
}
